import CommonTable from 'components/common/TableCommon';
import { IDeploymentVersion } from 'interface/deploymentInterface';
import { headCellList } from './common';
import { useEffect } from 'react';
import { useState } from 'react';
import { listDeploymentVersions } from 'services/deploymentService';
import { useAppSelector } from 'hooks/reduxHooks';
import { RootState } from 'redux-setup/store';
import { toast } from 'react-toastify';

export const DeploymentVersions = () => {
  const [deploymentVersionsData, setDeploymentVersionsData] = useState<
    IDeploymentVersion[]
  >([]);
  const [isNextAPIDisabled, setIsNextAPIDisabled] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const limit = 25;

  const organizationID = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const fetchDeploymentVersions = async () => {
    try {
      const res = await listDeploymentVersions({
        OrganizationID: organizationID,
        Page: page - 1,
        Limit: limit,
        Descending: true,
        OrderBy: 'CreatedAt',
      });
      const err = res.check();
      if (err) {
        toast.error('Error fetching deployment versions');
        return;
      }
      const deploymentVersions = res.unwrap();
      if (deploymentVersions.Result && deploymentVersions.Result.length > 0) {
        setDeploymentVersionsData(prev => [
          ...prev,
          ...deploymentVersions.Result,
        ]);
        setIsNextAPIDisabled(deploymentVersions.Result.length < limit);
      }
    } catch (error) {
      console.error('Error fetching deployment versions:', error);
    }
  };

  useEffect(() => {
    fetchDeploymentVersions();
  }, [page]);

  return (
    <>
      <CommonTable<IDeploymentVersion>
        headCellList={headCellList}
        data={deploymentVersionsData}
        isNextAPIDisabled={isNextAPIDisabled}
        onEndReached={() => {
          setPage(prev => prev + 1);
        }}
      />
    </>
  );
};
